import React from 'react';
import { Box } from '@mui/material';

const MonitoringCash: React.FC = () => {
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <iframe
        src="https://mtr.zerdegroup.kz/point"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
        title="Касса"
      />
    </Box>
  );
};

export default MonitoringCash; 